import { useCallback, useEffect, useState } from 'react'
import { getCrmPermissions, updateCrmPermissions } from '../services/crmPermissionsApi'
import type { CrmPermissions, CrmPermissionsUpdateInput } from '../types'

export function useCrmPermissions(workspaceId: string) {
  const [permissions, setPermissions] = useState<CrmPermissions | null>(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    getCrmPermissions(workspaceId)
      .then((p) => { if (!cancelled) setPermissions(p) })
      .catch((err) => { if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load CRM permissions') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [workspaceId])

  const save = useCallback(async (input: CrmPermissionsUpdateInput) => {
    setSaving(true)
    setError(null)
    try {
      const updated = await updateCrmPermissions(workspaceId, input)
      setPermissions(updated)
      return updated
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to save CRM permissions')
      throw err
    } finally {
      setSaving(false)
    }
  }, [workspaceId])

  return { permissions, loading, saving, error, setError, save }
}
